import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.common.white,
    position: "absolute",
    zIndex: 10000,
    padding: theme.spacing(0, 2),
  },
  text: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: theme.typography.pxToRem(20),
    lineHeight: "28px",
    marginTop: theme.spacing(2),
    color: theme.palette.common.fontTitle,
  },
  secondaryText: {
    textAlign: "center",
    fontSize: theme.typography.pxToRem(16),
    lineHeight: "28px",
    marginTop: theme.spacing(1),
    color: theme.palette.common.fontTitle,
  },
  redirectMsg: {
    textAlign: "center",
    fontSize: theme.typography.pxToRem(14),
    lineHeight: "28px",
    marginTop: theme.spacing(1),
    color: theme.palette.common.fontTitle,
  },
  imageContainer: {
    width: "200px",
  },
  refIdText: {
    fontWeight: "600",
    color: theme.palette.common.fontTitle,
  },
}));

export default useStyles;
